import axios from 'axios';
import { DOMAIN_URL } from '../../constants/url'; 

const axiosInstanceReport = axios.create({
  baseURL: DOMAIN_URL,  
  headers: {
    'Content-Type': 'application/json', 
  },
  responseType: "blob",  
});

axiosInstanceReport.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; 
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


export default axiosInstanceReport;
